package components.verticalDetailsCard


import csstype.FontWeight
import csstype.Length
import ics.utils.json.map
import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.FC
import react.create
import kotlin.js.Json

val VerticalDetailCard = FC<VerticalDetailCardProps>("VerticalDetailCard") {  props ->
    // vars
    val mappedData = props.cardData.unsafeCast<Json>().map()


    Card {
        props.title?.let {
            CardHeader {
                title = Typography.create{
                    variant = TypographyVariant.h6
                    + it
                }
            }
        }

        CardContent{
            Box {
                Table {
                    TableBody {
                        props.fieldsSequencedToShow.forEach { fieldToShow ->
                            TableRow {
                                val found = props.contentFieldMapping?.firstOrNull { it.fieldName == fieldToShow }
                                if (found != null) {
                                    TableCell{
                                        padding = TableCellPadding.none

                                        Typography {
                                            align = TypographyAlign.left
                                            +"${found.contentLabel}:"

                                            sx {
                                                fontWeight = FontWeight.bold
                                                width = Length.fitContent
                                            }
                                        }
                                    }
                                    TableCell{
                                        padding = TableCellPadding.none

                                        val arrayOfStrings = mappedData.get(found.fieldName)?.toString()?.split(";")?.toTypedArray() ?: arrayOf("...")

                                        arrayOfStrings.forEach {
                                            Typography {
                                                align = TypographyAlign.center

                                                sx {
                                                    fontWeight = FontWeight.normal
                                                }

                                                + it
                                            }
                                        }
                                    }

                                } else {
                                    TableCell {
                                        padding = TableCellPadding.none

                                        Typography {
                                            align = TypographyAlign.left
                                            sx {
                                                fontWeight = FontWeight.bold
                                                width = Length.fitContent
                                            }

                                            +"$fieldToShow:  "
                                        }
                                    }
                                    TableCell {
                                        padding = TableCellPadding.none

                                        val arrayOfStrings = mappedData.get(fieldToShow)?.toString()?.split(";")?.toTypedArray() ?: arrayOf("...")

                                        arrayOfStrings.forEach {
                                            Typography {
                                                align = TypographyAlign.center

                                                sx {
                                                    fontWeight = FontWeight.normal
                                                }

                                                + it
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}